import { LegalList } from './LegalList.component';
import { TermsDialog } from './TermsDialog.component';
import { TermsWrapper } from './TermsWrapper.component';

export default {
	LegalList,
	TermsDialog,
	TermsWrapper,
};
